import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';
import TextArea from 'components/application/TextArea';

export default function AddRequirementPriorityModal({
  courseName,
  isRequired,
  onClose,
  onConfirmAddRequirementPriority,
  personnelName,
}) {
  const [reason, setReason] = useState('');
  const newRequiredValue = !isRequired;
  const { t: i18nTCommon } = useTranslation('common');
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'training.requirementPriorityModals.AddRequirementPriorityModal',
  });
  const { t: i18nTShared } = useTranslation('components', {
    keyPrefix: 'training.requirementPriorityModals.shared',
  });

  const isSubmittable = reason.trim().length > 0;

  const handleConfirm = () => {
    if (isSubmittable) {
      onConfirmAddRequirementPriority(reason);
    }
  };

  const requirementStatus =
    newRequiredValue ?
      i18nTCommon('shared.requiredDowncase')
    : i18nTCommon('shared.optionalDowncase');

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTCommon('shared.cancel')}
          </TextButton>
          <FilledButton
            color='mint'
            disabled={!isSubmittable}
            onClick={handleConfirm}
          >
            {i18nT('button')}
          </FilledButton>
        </div>
      }
      isOpen={true}
      modalBoxClassName='tw-w-140'
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-6'>
        <h2 className='tw-m-0 tw-p-0 tw-text-xl tw-font-semibold tw-text-grey-900'>
          {i18nT('title')}
        </h2>
        <p className='tw-mb-6 tw-ml-0 tw-mr-0 tw-mt-2 tw-p-0 tw-text-m tw-font-normal tw-text-grey-700'>
          {i18nT('description', {
            interpolation: { escapeValue: false },
            courseName,
            personnelName,
            requirementStatus,
          })}
        </p>
        <TextArea
          additionalLabel={i18nTCommon('shared.required')}
          label={i18nTShared('form.label')}
          name='reason'
          onChange={(e) => setReason(e.target.value)}
          placeholderText={i18nTShared('form.placeholder')}
          value={reason}
        />
      </div>
    </ModalBox>
  );
}

AddRequirementPriorityModal.propTypes = {
  courseName: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirmAddRequirementPriority: PropTypes.func.isRequired,
  personnelName: PropTypes.string.isRequired,
};
